import { render, staticRenderFns } from "./summaryContactSold.vue?vue&type=template&id=7021cc6b&"
import script from "./summaryContactSold.vue?vue&type=script&lang=js&"
export * from "./summaryContactSold.vue?vue&type=script&lang=js&"
import style0 from "./summaryContactSold.vue?vue&type=style&index=0&id=7021cc6b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports